// Initialize and add the map
let map;

async function initMap() {
  var contactMap = document.getElementById('map')
  var latitude = parseFloat(contactMap.getAttribute('data-latitude'));
  var longitude = parseFloat(contactMap.getAttribute('data-longitude'));
  var icon = contactMap.getAttribute('data-icon');

  const markerImg = document.createElement("img");
  markerImg.src = icon;
  
  const position = { lat: latitude, lng: longitude };
  
  // Request needed libraries.
  //@ts-ignore
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  map = new Map(document.getElementById("map"), {
    zoom: 7,
    center: position,
    mapId: "2b8a62cd35548049",
  });

  const marker = new AdvancedMarkerElement({
    map: map,
    position: position,
    content: markerImg,
  });
}
initMap();